import * as ActionTypes from '../../actions/actionTypes'

const initialState = {
    pendingPushYearPrices: false,
    pendingPushYearRestrictions: false,
    pendingPushYearAvailability: false,
    pendingSynchronizeProperty: false
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.DOBOVO_PUSH_YEAR_PRICES_REQUEST:
            return { ...state, pendingPushYearPrices: true }
        case ActionTypes.DOBOVO_PUSH_YEAR_PRICES_SUCCESS:
        case ActionTypes.DOBOVO_PUSH_YEAR_PRICES_FAILURE:
            return { ...state, pendingPushYearPrices: false }

        case ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_REQUEST:
            return { ...state, pendingPushYearRestrictions: true }
        case ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_SUCCESS:
        case ActionTypes.DOBOVO_PUSH_YEAR_RESTRICTIONS_FAILURE:
            return { ...state, pendingPushYearRestrictions: false }

        case ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_REQUEST:
            return { ...state, pendingPushYearAvailability: true }
        case ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_SUCCESS:
        case ActionTypes.DOBOVO_PUSH_YEAR_AVAILABILITY_FAILURE:
            return { ...state, pendingPushYearAvailability: false }

        case ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_REQUEST:
            return { ...state, pendingSynchronizeProperty: true }
        case ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_SUCCESS:
        case ActionTypes.DOBOVO_SYNCHRONIZE_PROPERTY_FAILURE:
            return { ...state, pendingSynchronizeProperty: false }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/dobovoReducers/dobovoSync.js